var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg20250319200040568Copy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 269.91 90.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #d07a1d;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M72.1,40.15h8.6v34.09h-17.59V16.39h17.59v6.01h-11.58v45.79h6.24v-22.03h-3.26v-6.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M97,16.39h6.01v45.79h-7.78l7.78,12.06h-6.01l-5.58-8.6v8.6h-6.01V16.39h11.58ZM97,56.13V22.4h-5.58v33.73h5.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M107.72,74.23V16.39h6.05v57.84h-6.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.07,16.39h2.2l3.81,3.65v50.5l-3.81,3.69h-13.78V16.39h11.58ZM130.07,68.18V22.4h-5.58v45.79h5.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M140.79,29.66v-1.22h17.59v45.79h-17.59V29.66ZM146.8,34.49v33.69h5.58v-33.69h-5.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M172.09,40.15h8.6v34.09h-17.59V16.39h17.59v6.01h-11.58v45.79h6.24v-22.03h-3.26v-6.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M196.98,16.39h6.01v45.79h-7.78l7.78,12.06h-6.01l-5.58-8.6v8.6h-6.01V16.39h11.58ZM196.98,56.13V22.4h-5.58v33.73h5.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M219.29,16.39h6.01v57.84h-6.01v-12.17h-5.58v12.17h-6.01V16.39h11.58ZM219.29,56.01V22.43h-5.58v33.58h5.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M230.01,16.39h17.59v34.09h-11.58v23.76h-6.01V16.39ZM242.26,44.43v-22.03h-6.24v22.03h6.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M263.9,16.39h6.01v57.84h-6.01v-12.21h-5.58v12.21h-6.01V16.39h6.01v39.62h5.58V16.39Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 140.79,
    y: 16.39,
    width: 17.59,
    height: 6.01
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.72,8.21h22.69v49.47h-22.69V8.21ZM45.4,12.22h-14.68v41.45h14.68V12.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,0h22.69v49.47H0V0ZM18.68,4.01H4.01v41.45h14.68V4.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.72,61.45h22.69v29.17h-22.69v-29.17ZM45.4,65.46h-14.68v21.15h14.68v-21.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,53.24h22.69v29.17H0v-29.17ZM18.68,57.25H4.01v21.15h14.68v-21.15Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg20250319200040568Copy);
export default __webpack_public_path__ + "static/media/IMG_20250319_200040_568 - Copy.a2e0057add4eef4c965d567cf9376745.svg";
export { ForwardRef as ReactComponent };